import React from 'react';
import { FormattedNumber } from 'react-intl';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

const PriceItem: React.SFC<{
  price: number;
  decimals: number;
  style?: string;
}> = ({
  price,
  decimals = 0,
  style = '',
}) => (
  <span className={ style }>
    <FormattedNumber 
      value={ price } 
      minimumFractionDigits={ decimals }
    />&nbsp;
    <FormattedText
      displayName='SEK'
      formattedName='global.priceunit'
    />
  </span>
);

export default PriceItem;


// WEBPACK FOOTER //
// ./src/components/Shared/PriceItem/PriceItem.tsx